import { Root } from '@radix-ui/react-radio-group';
import * as React from 'react';
import { cn } from '@discover-lib/utils';

type RootType = typeof Root;

export type RadioGroupProps = React.ComponentPropsWithoutRef<RootType>;

const RadioGroup = React.forwardRef<React.ElementRef<RootType>, RadioGroupProps>(
  ({ className, orientation, ...props }, ref) => (
    <Root
      className={cn(
        'flex',
        // Custom fix for the 'orientation' bug on the shadcn-ui/radiogroup component, see https://github.com/shadcn-ui/ui/issues/1632
        { 'flex-col': orientation === 'vertical' },
        className
      )}
      {...props}
      ref={ref}
    />
  )
);

RadioGroup.displayName = Root.displayName;

export default RadioGroup;
